export enum CloneType {
    EVENT = 'EVENT',
    OFFER = 'OFFER',
    PROMO = 'PROMO',
    OFFERGROUP = 'OFFERGROUP',
    VERSION = 'VERSION'
}